/**
 * The viewer's past builds on the build tab: the ones they generated plus the ones they saved
 * (including builds the site served them by reuse), newest first. Nothing renders logged out.
 */
import { Link } from 'react-router';
import { useMe } from '../../api/client';
import { useMyBuilds } from '../../api/builds';
import { relativeTime } from '../../util/time';

export function YourBuilds() {
  const me = useMe();
  const userId = me.data?.user?.id ?? null;
  const builds = useMyBuilds(!!userId);
  if (!userId) return null;

  return (
    <section className="section" data-testid="your-builds">
      <h2>Your builds</h2>
      {builds.isPending ? (
        <p className="muted">Loading...</p>
      ) : !builds.data || builds.data.length === 0 ? (
        <p className="muted">No builds yet.</p>
      ) : (
        <div className="table-scroll">
          <table className="grid">
            <thead>
              <tr>
                <th>When</th>
                <th>Character</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {builds.data.map((b) => {
                const saved = !!b.saved;
                return (
                  <tr key={b.id} data-testid="your-build" data-status={b.status} data-saved={saved ? '' : undefined}>
                    <td>{relativeTime(b.createdAt)}</td>
                    <td>
                      {b.character.characterName ?? `Level ${b.character.level} ${b.character.race} ${b.character.class}`} &mdash;{' '}
                      {b.character.role}
                      {saved && <span className="muted"> (Saved)</span>}
                    </td>
                    <td>{b.removed ? 'removed' : b.status}</td>
                    <td>
                      <Link to={`/build/${b.id}`}>View</Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
